var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',_vm._b({attrs:{"error-messages":_vm.mensajeError},on:{"change":_vm.procesarFichero},model:{value:(_vm.fichero),callback:function ($$v) {_vm.fichero=$$v},expression:"fichero"}},'v-file-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }